import React from 'react';
import {connect} from 'react-redux';
import {Modal, PrimaryButton, SecondaryButton} from '../../components';
import * as Actions from '../../store/actions';

function ConfirmUnSaveFlowModal({
  handleSave,
  alertModal = false,
  setAlertModal,
  isLoading,
  handleExit,
}) {
  return (
    <Modal
      show={alertModal}
      modalTitle="You have unsaved actions"
      onClose={setAlertModal}
      extraModalClasses="max-w-[512px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
    >
      <div className="mt-4 px-6">
        <p className="text-start text-sm text-body font-medium">
          Your unsaved changes will be lost. Save changes before closing?
        </p>
      </div>

      <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
        <SecondaryButton
          onClick={handleExit}
          buttonText="Exit &  lose changes"
          className="w-[50%] !h-10"
        />
        <PrimaryButton
          onClick={handleSave}
          buttonText="Save"
          className="w-[50%] !h-10"
          loading={isLoading}
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(ConfirmUnSaveFlowModal);
